import { Dayjs } from "dayjs";

export default interface TrabalhoSituacao {
    codigo: number;
    nome: string;
    dataCriacao: Date | Dayjs;
}

export enum EnumTrabalhoSituacao {
    AExecutar = 1,
    Executando,
    Finalizado,
    Erro
}